import React from 'react';
import { formatTripDateRange, tripDurationDays } from '../utils';

// Dot-separated meta row: date range · N days · N alternatives. Days are
// omitted for open-ended trips (decision #1: hide). See design-handoff.md B.1.

export interface MetaLineProps {
  dateStart: string | null;
  dateEnd: string | null;
  alternativesCount: number;
  /** Appends " · round trip". Trip Detail passes params.roundTrip !== false
   *  (absent = round trip by silence); TripCard omits it. */
  roundTrip?: boolean;
  /** The brief's rough length, shown in place of the dates when there are none. */
  durationPreset?: string | null;
}

const dot = (
  <span aria-hidden style={{ opacity: 0.5 }}>·</span>
);

const MetaLine: React.FC<MetaLineProps> = ({ dateStart, dateEnd, alternativesCount, roundTrip, durationPreset }) => {
  const days = tripDurationDays(dateStart, dateEnd);
  const parts: React.ReactNode[] = [formatTripDateRange(dateStart, dateEnd, durationPreset)];
  if (days !== null) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
  parts.push(`${alternativesCount} ${alternativesCount === 1 ? 'alternative' : 'alternatives'}`);
  if (roundTrip) parts.push('round trip');

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#6c7872', fontSize: 13, flexWrap: 'wrap' }}>
      {parts.map((part, i) => (
        <React.Fragment key={i}>
          {i > 0 && dot}
          <span>{part}</span>
        </React.Fragment>
      ))}
    </div>
  );
};

export default MetaLine;
